/** @internal */
export const fastDeferSymbol = Symbol();
